import { render } from "./homeAiInstructor.vue?vue&type=template&id=04a08384&scoped=true"
import script from "./homeAiInstructor.vue?vue&type=script&lang=js"
export * from "./homeAiInstructor.vue?vue&type=script&lang=js"

import "./homeAiInstructor.vue?vue&type=style&index=0&id=04a08384&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a08384"]])

export default __exports__